import { useControllableValue } from 'ahooks';
import classNames from 'classnames';
import React, { createElement as _createElement } from 'react';
import Chips from '../chips';
import Dropdown from '../dropdown';
import EllipsisTooltip from '../ellipsis-tooltip';
import Spin from '../spin';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NomalChips = _ref => {
  let {
    type,
    item,
    disabled,
    value,
    onChange,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_createElement(Chips, {
    ...restProps,
    key: item.value,
    type: type,
    disabled: disabled || item.disabled,
    className: classNames('chipSelect-chip', {
      disabled: disabled || item.disabled
    }),
    height: 60,
    prefix: item.icon,
    active: item.value === value,
    onActiveChange: active => {
      if (active) {
        onChange(item.value, item);
      }
    }
  }, /*#__PURE__*/_jsxs("div", {
    className: "content",
    children: [/*#__PURE__*/_jsx(EllipsisTooltip, {
      className: "title",
      children: item.name
    }), (item === null || item === void 0 ? void 0 : item.desc) && /*#__PURE__*/_jsx(EllipsisTooltip, {
      className: "desc",
      children: item.desc
    })]
  }));
};
const HasDropdownChips = _ref2 => {
  var _item$dropdown, _item$dropdown3;
  let {
    type,
    item,
    disabled,
    value,
    onChange,
    ...restProps
  } = _ref2;
  const activeItem = item === null || item === void 0 || (_item$dropdown = item.dropdown) === null || _item$dropdown === void 0 ? void 0 : _item$dropdown.flatMap(i => {
    var _i$children;
    return (_i$children = i.children) !== null && _i$children !== void 0 ? _i$children : [i];
  }).find(i => i.value === value);
  return /*#__PURE__*/_jsx(Dropdown, {
    disabled: disabled || item.disabled,
    isScroll: true,
    menu: {
      selectable: true,
      selectedKeys: [value],
      onSelect: _ref3 => {
        var _item$dropdown2;
        let {
          key
        } = _ref3;
        onChange(key, item === null || item === void 0 || (_item$dropdown2 = item.dropdown) === null || _item$dropdown2 === void 0 ? void 0 : _item$dropdown2.flatMap(i => {
          var _i$children2;
          return (_i$children2 = i.children) !== null && _i$children2 !== void 0 ? _i$children2 : [i];
        }).find(i => i.value === key));
      },
      items: item === null || item === void 0 || (_item$dropdown3 = item.dropdown) === null || _item$dropdown3 === void 0 ? void 0 : _item$dropdown3.map(dropdownItem => {
        const item = {
          ...dropdownItem,
          // 用于透传自定义属性
          label: dropdownItem.name,
          key: dropdownItem.value,
          disabled: dropdownItem.disabled,
          danger: dropdownItem.danger
        };
        if (dropdownItem.children) {
          return {
            ...item,
            type: 'group',
            children: dropdownItem.children.map(it => ({
              ...it,
              // 用于透传自定义属性
              label: it.name,
              key: it.value,
              disabled: it.disabled,
              danger: it.danger
            }))
          };
        }
        return item;
      })
    },
    children: /*#__PURE__*/_createElement(Chips, {
      ...restProps,
      key: item.name,
      type: type,
      className: classNames('chipSelect-chip', {
        disabled: disabled || item.disabled
      }),
      disabled: disabled || item.disabled,
      height: 60,
      prefix: item.icon,
      active: !!activeItem
    }, /*#__PURE__*/_jsxs("div", {
      className: "content",
      children: [/*#__PURE__*/_jsx(EllipsisTooltip, {
        className: "title",
        children: item.name
      }), ((item === null || item === void 0 ? void 0 : item.placeholder) || !!activeItem) && /*#__PURE__*/_jsx(EllipsisTooltip, {
        className: classNames({
          placeholder: !activeItem,
          desc: activeItem
        }),
        children: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.name) || item.placeholder
      })]
    }))
  });
};
const ChipSelect = props => {
  const {
    data = [],
    column = 3,
    type = 'outline',
    disabled,
    loading = false,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-chipSelect");
  const [value, onChange] = useControllableValue(props, {
    defaultValue: undefined,
    defaultValuePropName: 'defaultValue',
    valuePropName: 'value',
    trigger: 'onChange'
  });

  // const hasDropdown = data?.[0]?.dropdown; //目前用这个判断

  return /*#__PURE__*/_jsx(Spin, {
    spinning: loading,
    children: /*#__PURE__*/_jsx("div", {
      className: classNames(className, baseClassName),
      style: {
        gridTemplateColumns: "repeat(".concat(column, ", 1fr)"),
        ...style
      },
      children: data.map(item => {
        if (item.dropdown) {
          return /*#__PURE__*/_jsx(HasDropdownChips, {
            type: type,
            item: item,
            disabled: disabled,
            value: value,
            onChange: onChange,
            ...restProps
          }, item.value || item.name);
        }
        return /*#__PURE__*/_jsx(NomalChips, {
          type: type,
          item: item,
          disabled: disabled,
          value: value,
          onChange: onChange,
          ...restProps
        }, item.value || item.name);
      })
    })
  });
};
export default ChipSelect;